"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeaturesIsLoading = exports.hasFeatureFlags = exports.hasFeatureFlag = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

var getFeaturesState = function getFeaturesState(state) {
  return state.modules.features;
};

var getFeatures = function getFeatures(state) {
  return state.modules.features.features;
};
/**
 * Takes feature flag name and returns a function that receives state and returns
 * feature flag value by his name.
 *
 * @example
 * const isEnabled = useSelector(hasFeatureFlag('instantGiftOptions'));
 *
 * @param {string} flag - Feature flag name.
 * @returns {function(state: Object)} - Application state.
 */


var hasFeatureFlag = function hasFeatureFlag(flag) {
  return R.pipe(getFeatures, function (features) {
    return features[flag];
  });
};
/**
 * Takes feature flag name and returns a function that receives state and returns
 * feature flag value by his name.
 *
 * @example
 * const isEnabled = useSelector(useMemo(() => hasFeatureFlags(['instantGiftOptions', 'prospectingCampaign']), []));
 *
 * @param {string} flag - Feature flag name.
 * @returns {function(state: Object)} - Application state.
 */


exports.hasFeatureFlag = hasFeatureFlag;

var hasFeatureFlags = function hasFeatureFlags(flags) {
  return (0, _reselect.createSelector)(getFeatures, function (features) {
    var parsedFlags = flags.split(',');
    return Object.keys(features).filter(function (featureKey) {
      return parsedFlags.includes(featureKey);
    }).some(function (featureKey) {
      return features[featureKey];
    });
  });
};

exports.hasFeatureFlags = hasFeatureFlags;
var getFeaturesIsLoading = R.pipe(getFeaturesState, function (state) {
  return state.isLoading;
});
exports.getFeaturesIsLoading = getFeaturesIsLoading;